import {appConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';
import getLocusUrlString from './get-locus-url-string';

const {defaultPartner} = appConfig;

export default function getGoSuggestSrpUrl({
  checkin,
  checkinTime,
  roomString,
  destination,
  locus,
  metaPartner = 'hourly',
  overriderankvhids,
  vendor,
  mmtId = '',
  country = '',
}) {
  const {date: checkinDate} = checkin;
  const {n: destinationCityName = '', _id, xtr = {}, ct = {}} = destination;
  let cityName = destinationCityName;
  let cityId = _id;
  const {cc = 'in'} = xtr; // default as india

  if (xtr && xtr.flt) {
    const {n: voyCityName = '', _id: voyCityId = ''} = ct;
    cityName = voyCityName;
    cityId = voyCityId;
  }

  // DAYUSE: extract these from a function.
  const ci_date = (checkinDate && `?checkin_date=${parseDateIntoHermesString(checkinDate)}`) || '?';
  const ci_time = (checkinTime && `&checkin_time=${checkinTime}`) || '';
  const rs = (roomString && `&roomString=${roomString}`) || '';

  const isVendor = (vendor && `?vendor=${vendor}`) || '';
  const locusUrlStr = getLocusUrlString(locus);
  const mmtIdStr = (mmtId && `&mmtId=${mmtId}`) || '';
  const countryStr = (country && `&cc=${country}`) || '';

  return `/hotels/find-gosuggest-hotels-in-${cityName}/${metaPartner}/${cityId}/${overriderankvhids}/${
    ci_date + ci_time + rs + isVendor + locusUrlStr + mmtIdStr
  }${countryStr}`;
}
